import { render } from "./AppointmentDataPetDataForm.vue?vue&type=template&id=a2e9a6fa&scoped=true&ts=true"
import script from "./AppointmentDataPetDataForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentDataPetDataForm.vue?vue&type=script&lang=ts"

import "./AppointmentDataPetDataForm.vue?vue&type=style&index=0&id=a2e9a6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e9a6fa"]])

export default __exports__